import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Desde que comenzamos a leer estas historias antes de dormir, mi hijo se siente mucho más calmado y relajado. Ahora espera ese momento con ilusión cada noche.',
    name: 'Lucía M.'
  }, {
    quote: 'Los niños conectaron muchísimo con los cuentos. Logran comprender enseñanzas espirituales profundas de una manera ligera y amorosa.',
    name: 'Rodrigo P.'
  }, {
    quote: 'Es una guía hermosa para compartir en familia. Cada relato transmite paz, ternura y valores que realmente llegan al corazón.',
    name: 'Mariana S.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-indigo text-cream relative" data-id="element-213">
      <div className="max-w-6xl mx-auto" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-215">
          <h2 className="text-4xl md:text-5xl font-serif font-medium mb-6" data-id="element-216">
            Mamás y papás que ya descansan
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-217">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-indigo-light p-8 rounded-3xl" data-id="element-218">
              <div className="flex text-gold mb-6" data-id="element-219">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-220" />)}
              </div>
              <p className="text-lg leading-relaxed mb-8 italic text-cream/90" data-id="element-221">
                "{testimonial.quote}"
              </p>
              <p className="font-serif font-medium text-xl text-gold" data-id="element-222">
                {testimonial.name}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}